import { useState } from 'react'
import PublicLayout from '../components/layout/PublicLayout'
import { sendContact, ApiHttpError } from '../utils/api'

export default function Contact() {
  const [name, setName] = useState('')
  const [email, setEmail] = useState('')
  const [message, setMessage] = useState('')
  const [status, setStatus] = useState<'idle' | 'sending' | 'sent'>('idle')
  const [error, setError] = useState('')

  const submit = async (e: React.FormEvent) => {
    e.preventDefault()
    if (!message.trim()) {
      setError('Please enter a message')
      return
    }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim())) {
      setError('Please enter a valid email so we can reply')
      return
    }
    setStatus('sending')
    setError('')
    try {
      await sendContact(name.trim(), email.trim(), message.trim())
      setStatus('sent')
    } catch (err) {
      setError(err instanceof ApiHttpError ? err.message : 'Could not send — please email us directly')
      setStatus('idle')
    }
  }

  return (
    <PublicLayout>
      <div className="mx-auto max-w-2xl px-6 py-16">
        <p className="font-display text-sm font-bold uppercase tracking-widest text-[var(--accent-teal)]">Contact</p>
        <h1 className="font-display mt-2 text-4xl font-extrabold leading-tight md:text-5xl">Get in touch.</h1>
        <p className="mt-6 text-lg leading-relaxed text-[var(--text-secondary)]">
          Questions, feedback, bug reports or feature ideas — all welcome. We read everything and aim to reply
          within a few days.
        </p>

        {status === 'sent' ? (
          <div className="mt-10 rounded-2xl border border-[var(--accent-teal)] bg-[var(--bg-secondary)]/60 p-8 text-center backdrop-blur-sm">
            <div className="text-3xl">✅</div>
            <h2 className="font-display mt-3 text-xl font-bold">Message sent</h2>
            <p className="mt-2 text-[var(--text-secondary)]">Thanks — we'll get back to you at {email}.</p>
          </div>
        ) : (
          <form onSubmit={submit} className="mt-10 space-y-4 rounded-2xl border border-[var(--border)] bg-[var(--bg-secondary)]/60 p-6 backdrop-blur-sm">
            <div className="grid gap-4 sm:grid-cols-2">
              <div>
                <label className="mb-1 block text-sm text-[var(--text-secondary)]">Name (optional)</label>
                <input className="w-full" value={name} onChange={(e) => setName(e.target.value)} disabled={status === 'sending'} />
              </div>
              <div>
                <label className="mb-1 block text-sm text-[var(--text-secondary)]">Email</label>
                <input className="w-full" type="email" value={email} onChange={(e) => setEmail(e.target.value)} disabled={status === 'sending'} />
              </div>
            </div>
            <div>
              <label className="mb-1 block text-sm text-[var(--text-secondary)]">Message</label>
              <textarea className="w-full" rows={6} value={message} onChange={(e) => setMessage(e.target.value)} disabled={status === 'sending'} />
            </div>
            {error && <p className="text-sm text-[var(--bac-danger)]">{error}</p>}
            <button type="submit" disabled={status === 'sending'} className="btn btn-primary w-full py-3 font-semibold">
              {status === 'sending' ? 'Sending…' : 'Send message'}
            </button>
          </form>
        )}
      </div>
    </PublicLayout>
  )
}
